import React from 'react';
import { Switch, Route as RouteDOM } from 'react-router-dom';
import Route from './Route';

import { BackofficeContextProvider } from '../context';

import ROUTES from './constants';

const Login = React.lazy(() => import('../pages/Backoffice/Login/Login'));
const Home = React.lazy(() => import('../pages/Backoffice/Home/Home'));
const ClientList = React.lazy(() =>
  import('../pages/Backoffice/registrations/Client/ClientList/ClientList'),
);
const ClientView = React.lazy(() =>
  import('../pages/Backoffice/registrations/Client/ClientView/ClientView'),
);
const UserList = React.lazy(() =>
  import('../pages/Backoffice/registrations/User/UserList/UserList'),
);
const UserRegister = React.lazy(() =>
  import('../pages/Backoffice/registrations/User/UserRegister/UserRegister'),
);
const ProfileList = React.lazy(() =>
  import('../pages/Backoffice/registrations/Profile/ProfileList/ProfileList'),
);
const ProfileRegister = React.lazy(() =>
  import(
    '../pages/Backoffice/registrations/Profile/ProfileRegister/ProfileRegister'
  ),
);
const Schedules = React.lazy(() =>
  import('../pages/Backoffice/registrations/Schedules/Schedules'),
);
const SystemMenuItemList = React.lazy(() =>
  import(
    '../pages/Backoffice/registrations/SystemMenuItem/SystemMenuItemList/SystemMenuItemList'
  ),
);
const SystemMenuItemRegister = React.lazy(() =>
  import(
    '../pages/Backoffice/registrations/SystemMenuItem/SystemMenuItemRegister/SystemMenuItemRegister'
  ),
);
const MenuItemList = React.lazy(() =>
  import(
    '../pages/Backoffice/registrations/MenuItem/MenuItemList/MenuItemList'
  ),
);
const MenuItemRegister = React.lazy(() =>
  import(
    '../pages/Backoffice/registrations/MenuItem/MenuItemRegister/MenuItemRegister'
  ),
);
const OrderDetail = React.lazy(() =>
  import('../pages/Backoffice/OrderDetail/OrderDetail'),
);

const OrdersPerDay = React.lazy(() =>
  import('../pages/Backoffice/Reports/OrdersPerDay/OrdersPerDay'),
);
const MostOrderedMenuItem = React.lazy(() =>
  import('../pages/Backoffice/Reports/MostOrderedMenuItem/MostOrderedMenuItem'),
);
const RevenuePerDay = React.lazy(() =>
  import('../pages/Backoffice/Reports/RevenuePerDay/RevenuePerDay'),
);
const TopFiveOrderedClients = React.lazy(() =>
  import(
    '../pages/Backoffice/Reports/TopFiveOrderedClients/TopFiveOrderedClients'
  ),
);
const NewClientsPerDay = React.lazy(() =>
  import('../pages/Backoffice/Reports/NewClientsPerDay/NewClientsPerDay'),
);

const Samples = React.lazy(() => import('../pages/Backoffice/Samples/Samples'));

export const BackofficeRoutes = () => (
  <BackofficeContextProvider>
    <Switch>
      <Route path={ROUTES.BACKOFFICE.LOGIN} component={Login} exact />
      <Route path={ROUTES.BACKOFFICE.HOME} component={Home} isPrivate exact />
      <Route
        path={ROUTES.BACKOFFICE.ORDER}
        component={OrderDetail}
        isPrivate
        exact
      />

      <Route
        path={ROUTES.BACKOFFICE.REGISTER_USER_LIST}
        component={UserList}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REGISTER_USER_CREATE}
        component={UserRegister}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REGISTER_USER_UPDATE}
        component={UserRegister}
        isPrivate
        exact
      />

      <Route
        path={ROUTES.BACKOFFICE.REGISTER_PROFILE_LIST}
        component={ProfileList}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REGISTER_PROFILE_CREATE}
        component={ProfileRegister}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REGISTER_PROFILE_UPDATE}
        component={ProfileRegister}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REGISTER_SYSTEM_MENU_ITEM_LIST}
        component={SystemMenuItemList}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REGISTER_SYSTEM_MENU_ITEM_CREATE}
        component={SystemMenuItemRegister}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REGISTER_SYSTEM_MENU_ITEM_UPDATE}
        component={SystemMenuItemRegister}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REGISTER_SCHEDULES}
        component={Schedules}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REGISTER_MENU_ITEM_LIST}
        component={MenuItemList}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REGISTER_MENU_ITEM_CREATE}
        component={MenuItemRegister}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REGISTER_MENU_ITEM_UPDATE}
        component={MenuItemRegister}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REGISTER_CLIENT_LIST}
        component={ClientList}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REGISTER_CLIENT_VIEW}
        component={ClientView}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REPORTS_ORDERS_PER_DAY}
        component={OrdersPerDay}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REPORTS_MOST_ORDERED_MENU_ITEM}
        component={MostOrderedMenuItem}
        isPrivate
        exact
      />
      <Route
        path={ROUTES.BACKOFFICE.REPORTS_REVENUE_PER_DAY}
        component={RevenuePerDay}
        isPrivate
      />
      <Route
        path={ROUTES.BACKOFFICE.REPORTS_TOP_FIVE_ORDERED_CLIENTS}
        component={TopFiveOrderedClients}
        isPrivate
      />
      <Route
        path={ROUTES.BACKOFFICE.REPORTS_NEW_CLIENTS_PER_DAY}
        component={NewClientsPerDay}
        isPrivate
        exact
      />
      <RouteDOM path="/samples" component={Samples} />
    </Switch>
  </BackofficeContextProvider>
);

export default BackofficeRoutes;
